/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import {
  ExperienceContext
} from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  Button,
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Typography
} from '@one-thd/sui-atomic-components';

const SubscribeDrawer = ({
  discount = 0,
  openDrawer = false,
  onCloseClick = () => { },
  onIUnderstandClick = () => { }
}) => {

  const { channel = 'desktop' } = useContext(ExperienceContext);

  const closeDrawer = () => {
    onCloseClick();
  };

  const onIUnderstand = () => {
    window.LIFE_CYCLE_EVENT_BUS.trigger('cart.subscription-acknowledgement');
    onIUnderstandClick();
  };

  return (
    <QueryProvider cacheKey="subscribe-drawer">
      <Drawer
        open={openDrawer}
        onClose={() => closeDrawer()}
        DrawerRootProps={{ style: channel === 'desktop' ? { maxWidth: '500px', justifySelf: 'flex-end' } : {} }}
      >
        <DrawerHeader title="Subscription Details" onClose={() => closeDrawer()} />
        <DrawerBody>
          <div className="sui-pl-4">
            <Typography height="normal">
              <ul className="sui-list-disc sui-list-outside">
                <li>
                  You’ll be charged the cost of the item at a
                  <span className="sui-font-bold"> {discount || 5}% discount </span>
                  (plus applicable taxes) on the day of each scheduled order.
                </li>
                <li>You have until the day before the item is ordered to cancel.</li>
                <li>You can cancel by visiting the subscriptions page on your Account Dashboard</li>
              </ul>
            </Typography>
          </div>
        </DrawerBody>
        <DrawerFooter className="sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky">
          <div className="sui-mt-2">
            <Button fullWidth onClick={() => onIUnderstand()}>I understand</Button>
          </div>
          <div className="sui-mt-4">
            <Button fullWidth variant="secondary" onClick={() => closeDrawer()}>Cancel</Button>
          </div>
        </DrawerFooter>
      </Drawer>
    </QueryProvider>
  );
};

SubscribeDrawer.propTypes = {};

SubscribeDrawer.defaultThemeProps = {};

export { SubscribeDrawer };
